import React, { FC, useRef } from "react";
import { Col, Form, Input, Row, Select, message } from "antd";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "../../../../../constants/world.json";

import Modal from "@components/Modal";
import Button from "@components/Button";
import { IModal } from "@types";
import { ErrorServices } from "@/services";
import { useAddSubAdminMutation } from "@/services/sub.admin";

interface IProps extends IModal {
  refetch?: () => void;
}

const AddTomUser: FC<IProps> = ({ isVisible, setIsVisible, refetch }) => {
  const [form] = Form.useForm();

  const [addSubAdmin, { isLoading }] = useAddSubAdminMutation();

  const closeModal = () => {
    form.resetFields();
    setIsVisible(false);
  };

  const onSubmit = async (payload: any) => {
    try {
      payload.phone_code = payload.contact_number.code;
      payload.phone_number = payload.contact_number.phone;

      delete payload.contact_number;

      await addSubAdmin(payload).unwrap();

      message.success("Tom User has been successfully created.");

      refetch?.();

      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  return (
    <Modal
      width={700}
      title="Create Tom User"
      isVisible={isVisible}
      onClose={closeModal}
      footer={[
        <Button
          key="1"
          variant="buttonCore"
          className="w-56"
          isLoading={isLoading}
          onClick={() => form.submit()}
        >
          Create
        </Button>,

        <Button
          key="2"
          variant="buttonBlue"
          className="w-28"
          onClick={closeModal}
        >
          Cancel
        </Button>,
      ]}
    >
      <ConfigProvider locale={en}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            contact_number: {
              short: "us",
            },
          }}
          onFinish={onSubmit}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label="First name"
                name="first_name"
                rules={[
                  {
                    required: true,
                    message: "Please enter first name",
                  },
                ]}
              >
                <Input placeholder="Enter first name here..." />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Last name"
                name="last_name"
                rules={[
                  {
                    required: true,
                    message: "Please enter last name",
                  },
                ]}
              >
                <Input placeholder="Enter last name here..." />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Contact number"
                name="contact_number"
                rules={[
                  {
                    required: true,
                    message: "Please enter contact number",
                  },
                ]}
              >
                <CountryPhoneInput />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Email address"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input placeholder="Enter email address here..." />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Role"
                name="role"
                rules={[
                  {
                    required: true,
                    message: "Please select role",
                  },
                ]}
              >
                <Select size="large" placeholder="Select role from here...">
                  <Select.Option value="TOM_SUPER_USER">
                    Super User
                  </Select.Option>

                  <Select.Option value="TOM_ADMIN">Admin</Select.Option>

                  <Select.Option value="TOM_SALES">Sales</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </ConfigProvider>
    </Modal>
  );
};

export default AddTomUser;
